const changeLanguage = (lang = 'en') => {
	return { lang: lang, type: 'CHANGE_LANG' };
};

const data = {
	changeLanguage,
};
export default data;
